// Copyright (c) Move Closer 2022.

import { SearchResultItemTab } from '../../shared/services/search'

import { SearchResultsConfig } from '../../../contexts'

import { SearchResultProductItem } from '../organisms/SearchResultProductItem'
import { searchResultProductResolver } from '../organisms/SearchResultProductItem/resolver'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const searchResultPreview: SearchResultsConfig = {
  products: {
    label: 'some.key.to.translations',
    component: SearchResultProductItem
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const searchResultConfig: SearchResultItemTab[] = [{
  label: 'some.key.to.translations',
  value: 'products',
  priority: 100,
  preview: searchResultPreview,
  resolver: searchResultProductResolver
}]
